import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const FILENAME = '2026-SAA-Step-Workshop-flyer.pdf';

/** Letter page with 0.25in margin — matches .flyer in workshopFlyerPage.module.css */
const PDF_MARGIN_PT = 18;

function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/** Render the on-screen flyer element to a one-page letter PDF (matches HTML layout). */
export async function buildWorkshopFlyerPdfFromElement(element: HTMLElement): Promise<jsPDF> {
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
    logging: false,
    width: element.offsetWidth,
    height: element.offsetHeight,
    windowWidth: element.offsetWidth,
    windowHeight: element.offsetHeight,
  });

  const doc = new jsPDF({ unit: 'pt', format: 'letter', orientation: 'portrait' });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const maxWidth = pageWidth - PDF_MARGIN_PT * 2;
  const maxHeight = pageHeight - PDF_MARGIN_PT * 2;

  const scale = Math.min(maxWidth / canvas.width, maxHeight / canvas.height);
  const renderWidth = canvas.width * scale;
  const renderHeight = canvas.height * scale;
  const x = (pageWidth - renderWidth) / 2;
  const y = PDF_MARGIN_PT;

  doc.addImage(canvas.toDataURL('image/png'), 'PNG', x, y, renderWidth, renderHeight);
  return doc;
}

export async function downloadWorkshopFlyerPdf(element: HTMLElement): Promise<void> {
  const doc = await buildWorkshopFlyerPdfFromElement(element);
  triggerBlobDownload(doc.output('blob'), FILENAME);
}

export async function openWorkshopFlyerPdfForPrint(element: HTMLElement): Promise<void> {
  const doc = await buildWorkshopFlyerPdfFromElement(element);
  const url = URL.createObjectURL(doc.output('blob'));
  window.open(url, '_blank', 'noopener,noreferrer');
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
